// extracted by mini-css-extract-plugin
export default {"wrap":"wF-z","subtitle":"xF-z","contentWrap":"yF-z","imgWrap":"zF-z","heading":"AF-z","copy":"BF-z"};